module.exports = __webpack_public_path__ + "static/img/fefco202_1.785f645.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/fefco202_1.png
// module id = BojB
// module chunks = 0